import PassManager from "../assets/passManager.png";
import PFEProgress from "../assets/pfeProgress.png";
import SQLICostumerPortal from "../assets/SQLICostumerPortal.png";
import TechFormating from "../assets/techFormating.png";
import CleanIt from "../assets/cleanIt.png";
import IgniteSocial from "../assets/ignite-social.png";
import PortfolioGenerator from "../assets/portfolio-generator.png";
import ShoppingCart from "../assets/shopping-cart.png";
import RandomQuoteLoader from "../assets/random-quote-loader.png";
import Kicktok from "../assets/kicktock.png";
import GlamHaven from "../assets/glam-haven.png";
export const ProjectList = [
  {
    name: "Ticktock Clone",
    image: Kicktok,
    skills: "Next, React, Zustand, TypeScript, TailwindCSS, NodeJS",
    github: "https://github.com/Imanebln/nextjs-kicktok-app.git",
    demo: "https://next-kicktok.vercel.app/",
  },
  {
    name: "E-commerce makeup website",
    image: GlamHaven,
    skills: "Vue, Vuex, Javascript, CSS, Firebase",
    github: "https://github.com/Imanebln/vue-makeup-ecommerce-website.git",
    demo: "https://iboulouane-glam-haven.netlify.app/",
  },
  {
    name: "Password Manager",
    image: PassManager,
    skills: "TS, Angular, C#, .NET, xunit, MongoDB, Git",
    github: "https://github.com/Imanebln/password-manager-aspnetcore.git",
  },
  {
    name: "PFE Progress",
    image: PFEProgress,
    skills: "JS, ReactJS, C#, .NET, MS SQL, Git",
    github: "https://github.com/Imanebln/PFAProject.git",
  },
  {
    name: "SQLI Customers Portal",
    image: SQLICostumerPortal,
    skills: "TS, Angular, MaterialUI, C#, .NET, xunit, MS SQL, Git",
    github: "https://github.com/Imanebln/CRMProject1.0.git",
  },
  {
    name: "Tech Formating",
    image: TechFormating,
    skills: "TS, Angular, Ionic, Firebase, Git",
    github: "https://github.com/Imanebln/TechFormating.git",
  },
  {
    name: "Clean It",
    image: CleanIt,
    skills: "Java, Android Studio, SQLite, Git",
    github: "https://github.com/Imanebln/CleanIt_Laundry_Service.git",
  },
  {
    name: "Ignite-Social",
    image: IgniteSocial,
    skills: "ReactJS, Express, JS, MUI, Git",
    github: "https://github.com/Imanebln/react-social-media-website.git",
  },
  {
    name: "Portfolio Generator",
    image: PortfolioGenerator,
    skills: "ReactJS, Redux, JS, CSS, MUI ",
    github: "https://github.com/Imanebln/react-personal-portfolio.git",
  },
  {
    name: "Gym Room Supplier",
    image: ShoppingCart,
    skills: "ReactJS, JS, React-Bootstrap, Context API",
    github: "https://github.com/Imanebln/react-ts-shopping-cart.git",
  },
  {
    name: "Random Quote Loader",
    image: RandomQuoteLoader,
    skills: "ReactJS, JS, CSS",
    github: "",
    demo: "https://random-quote-loader.netlify.app/",
  },
];
